import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TenantRelationship } from 'src/types/tenant-relationship';

interface PartnershipState {
  sourcePartners: TenantRelationship[];
  targetPartners: TenantRelationship[];
  selectedPartner: string;
  selectedPartnerRole: 'source' | 'target'; // Role can be 'source' or 'target'
  isLoaded: boolean;
}

const initialState: PartnershipState = {
  sourcePartners: [],
  targetPartners: [],
  selectedPartner: '',
  selectedPartnerRole: 'target', // Default role can be 'source' or 'target'
  isLoaded: false,
};

const partnershipSlice = createSlice({
  name: 'partnership',
  initialState,
  reducers: {
    setSourcePartners(state, action: PayloadAction<TenantRelationship[]>) {
      state.sourcePartners = action.payload;
    },
    setTargetPartners(state, action: PayloadAction<TenantRelationship[]>) {
      state.targetPartners = action.payload;
    },
    setSelectedPartner(state, action: PayloadAction<string>) {
      state.selectedPartner = action.payload;
    },
    setIsPartnershipLoaded(state, action: PayloadAction<boolean>) {
      state.isLoaded = action.payload;
    },
    setSelectedPartnerRole(state, action: PayloadAction<'source' | 'target'>) {
      state.selectedPartnerRole = action.payload;
    }
  },
});

export const { setSelectedPartner, setSourcePartners, setTargetPartners, setSelectedPartnerRole, setIsPartnershipLoaded } = partnershipSlice.actions;
export default partnershipSlice.reducer;